import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9135fcee"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popUp"
}
const _hoisted_2 = {
  class: "wrapper",
  ref: "modal"
}
const _hoisted_3 = { class: "wrapper-title" }
const _hoisted_4 = { class: "wrapper-subtitle" }
const _hoisted_5 = { class: "wrapper-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drive_input = _resolveComponent("drive-input")!
  const _component_app_skeleton_case_edit = _resolveComponent("app-skeleton-case-edit")!
  const _component_app_upload_info = _resolveComponent("app-upload-info")!
  const _component_app_loader = _resolveComponent("app-loader")!

  return (_ctx.isShow)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$localize('create.case.popup.title')), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$localize('create.case.popup.add.name')), 1)
          ]),
          _createVNode(_component_drive_input, {
            modelValue: _ctx.caseTitle,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.caseTitle) = $event)),
            title: _ctx.$localize('create.case.popup.name.placeholder'),
            bold: "",
            error: _ctx.error
          }, null, 8, ["modelValue", "title", "error"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", {
              class: "btn btn-cancel",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]))
            }, _toDisplayString(_ctx.$localize('create.case.popup.cancel.button')), 1),
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleCreateCase && _ctx.handleCreateCase(...args))),
              class: _normalizeClass([{ 'disabled': _ctx.disabled }, "btn btn-create"])
            }, _toDisplayString(_ctx.$localize('create.case.popup.create.button')), 3)
          ])
        ], 512),
        (_ctx.isProgress)
          ? (_openBlock(), _createBlock(_component_app_skeleton_case_edit, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.isUploading)
          ? (_openBlock(), _createBlock(_component_app_loader, {
              key: 1,
              message: _ctx.loaderText
            }, {
              default: _withCtx(() => [
                (_ctx.isUploading && _ctx.uploadInfo.total)
                  ? (_openBlock(), _createBlock(_component_app_upload_info, {
                      key: 0,
                      "upload-info": _ctx.uploadInfo,
                      onCancelUpload: _ctx.cancelUpload
                    }, null, 8, ["upload-info", "onCancelUpload"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["message"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}